var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTapProject4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 3,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08008 8.50977L7.00977 3.92969H9.10938V8.5H9.96875V9.80859H9.10938V11H7.51758V9.80859H4.08008V8.50977ZM7.54688 8.5V5.69727H7.48828L5.74023 8.44141V8.5H7.54688Z",
    fill: "#19191B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapProject4);
export default __webpack_public_path__ + "static/media/tap_project4.cfe025a0a886ec62e1c39617d25fa8ee.svg";
export { ForwardRef as ReactComponent };